import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, CreditCard, Headphones, LogOut } from 'lucide-react';

export default function SubscriptionExpired() {
  const navigate = useNavigate();

  // If the visitor landed here because of a stale token (onboarding-in-
  // progress account wrongly routed to /subscription-expired), bounce them
  // back to /onboarding the moment we see the account is clearly not in
  // "expired subscription" territory. Same check the ProtectedRoute does —
  // belt and suspenders.
  useEffect(() => {
    try {
      const tenant = JSON.parse(localStorage.getItem('tenant') || '{}');
      const status = tenant?.accountStatus;
      if (status && status !== 'active') {
        navigate('/onboarding', { replace: true });
      }
    } catch { /* ignore */ }
  }, [navigate]);

  const hardLogout = () => {
    // Clear every shred of auth/session state and force a full reload so
    // React state, in-memory caches, and any running XHR retry loops all
    // die together. This is the guaranteed escape hatch for users who got
    // stuck on this page — e.g. after an account-state mismatch.
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch { /* ignore */ }
    window.location.href = '/login';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" dir="rtl">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-8 h-8 text-amber-600" />
        </div>
        <h2 className="text-xl font-bold text-gray-800 mb-3">انتهى اشتراكك</h2>
        <p className="text-sm text-gray-500 mb-6 leading-relaxed">
          انتهت فترة اشتراكك أو تجربتك المجانية. لاستئناف استخدام النظام، يرجى تجديد اشتراكك.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/settings/subscription/renew')}
            className="w-full flex items-center justify-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-xl text-sm font-bold hover:bg-blue-700 transition-colors"
          >
            <CreditCard className="w-4 h-4" />
            اشترك الآن
          </button>

          <a
            href="mailto:support@listechs.com"
            className="w-full flex items-center justify-center gap-2 bg-gray-100 text-gray-700 px-6 py-3 rounded-xl text-sm font-semibold hover:bg-gray-200 transition-colors"
          >
            <Headphones className="w-4 h-4" />
            تواصل مع الدعم
          </a>

          <button
            onClick={hardLogout}
            className="w-full flex items-center justify-center gap-2 bg-transparent text-gray-500 px-6 py-3 rounded-xl text-sm font-medium hover:bg-gray-50 transition-colors border border-gray-200"
          >
            <LogOut className="w-4 h-4" />
            تسجيل الخروج والعودة للدخول
          </button>
        </div>

        <p className="text-xs text-gray-400 mt-6">
          بياناتك محفوظة بأمان ولن تُحذف. يمكنك استعادة الوصول فوراً بعد الاشتراك.
        </p>
      </div>
    </div>
  );
}
